import { sortBy } from 'es-toolkit';
import i18n from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getErrorMessageFromAPI } from '../../utilz';
import {
  convertRateEnginApiResponseToRateShopModule,
  convertRateShopUiToRateEngine,
} from '../../utilz/shipmentDataManupulation';
import { setAppLoader } from '../common/CommonActions';
import { getTaxTypesEffects } from '../lookups/LookupsEffects';
import {
  getAccessorialsListInError,
  getAccessorialsListInSuccess,
  getCarriersByCustomerInError,
  getCarriersByCustomerInSuccess,
  getRateShopResultsForRateShopModuleError,
  getRateShopResultsForRateShopModuleSuccess,
  getTaxListInError,
  getTaxListInSuccess,
} from './RateShopActions';
import {
  getAccessorialsListEffect,
  getCarriersByCustomerEffect,
  getRateShopRateResultsEffect,
} from './RateShopEffects';
import RateShopTypes from './RateShopTypes';

function* getCarriersByCustomer({ payload }) {
  try {
    yield put(setAppLoader(true));
    const { data } = yield call(getCarriersByCustomerEffect, payload);
    yield put(
      getCarriersByCustomerInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(getCarriersByCustomerInError({ message: getErrorMessageFromAPI(e) }));
    yield put(setAppLoader(false));
  }
}

function* getAccessorialsList({ payload }) {
  try {
    yield put(setAppLoader(true));
    let { data } = yield call(getAccessorialsListEffect, payload);
    if (data) {
      data = sortBy(data, ['codeDesc', ['asc']]);
      const fueChargeIndex = data?.findIndex((item) => item.codeId === 'FUE');
      const fueChargeInfo = data[fueChargeIndex];
      fueChargeInfo.isChecked = true;
      data.splice(fueChargeIndex, 1);
      data = [fueChargeInfo, ...data];
    }
    yield put(
      getAccessorialsListInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(getAccessorialsListInError({ message: getErrorMessageFromAPI(e) }));
    yield put(setAppLoader(false));
  }
}

function* getTaxList({ payload }) {
  try {
    yield put(setAppLoader(true));
    let { data } = yield call(getTaxTypesEffects, payload);
    if (data) {
      data = sortBy(data, ['codeDesc', ['asc']]);
      const vatIndex = data?.findIndex((item) => item.codeId === 'VAT');
      const vatInfo = data[vatIndex];
      vatInfo.isChecked = true;
      data.splice(vatIndex, 1);
      data = [vatInfo, ...data];
    }
    yield put(
      getTaxListInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(getTaxListInError({ message: getErrorMessageFromAPI(e) }));
    yield put(setAppLoader(false));
  }
}

function* getRateResultsCustomer({ payload }) {
  try {
    const { data } = yield call(getRateShopRateResultsEffect, convertRateShopUiToRateEngine(payload));
    yield put(
      getRateShopResultsForRateShopModuleSuccess({
        data: convertRateEnginApiResponseToRateShopModule(data),
      }),
    );
  } catch (e) {
    yield put(
      getRateShopResultsForRateShopModuleError({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.currentlyRatingResults')),
      }),
    );
  }
}

export default function* RateShopSaga() {
  yield takeLatest(RateShopTypes.GET_CARRIERS_BY_CUSTOMER_PROGRESS, getCarriersByCustomer);
  yield takeLatest(RateShopTypes.GET_ACCESSORIALS_LIST_PROGRESS, getAccessorialsList);
  yield takeLatest(RateShopTypes.GET_TAX_LIST_PROGRESS, getTaxList);
  yield takeLatest(RateShopTypes.GET_RATE_RESULTS_PROGRESS, getRateResultsCustomer);
}
